import { Stack, Text } from "@mantine/core"
import { CountryCell } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { InlineBanner } from "~/components/InlineBanner"
import { FindCertificateRequestsForSupplierResponseDto } from "~/gen/api"
import { COUNTRIES } from "~/utils/countries"
import { formatAddress } from "~/utils/format-address"

type Props = {
  productionSite: FindCertificateRequestsForSupplierResponseDto["productionSite"]
}
export function CertificateRequestProductionSite({ productionSite }: Props) {
  const { t } = useTranslation("traceability")
  if (!productionSite)
    return (
      <InlineBanner
        message={
          <Text c="blue.9">{t("certificates.productionSitePending")}</Text>
        }
        size="xs"
        type="info"
        closable={false}
        w="fit-content"
      />
    )
  return (
    <Stack gap={0}>
      <Text fw={600}>{t("certificates.productionSite")}</Text>
      <Stack gap={0}>
        <Text fw={500}>{productionSite.name}</Text>
        <Stack c="gray" gap={0}>
          <Text fz="xxs" fs="italic">
            {formatAddress(productionSite)}
          </Text>
          <CountryCell
            countryIso3166={productionSite.countryIso3166}
            countriesMapper={COUNTRIES}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
